var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import React, { useMemo, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import SearchBar from "@frameworks/web/components/generic/SearchBar";
import ServiceRequestTablemb from "./ServiceRequestTablemb";
import moment from "moment";
import { EServiceRequest, SRRedirectionUrl, SRStatusDefaultMapping, SRStatusMapping, prefilledFormTypes, } from "./constant";
import DynamicPagination from "@frameworks/shared-library/components/Pagination/Pagination";
import ServiceTableAcc from "./ServiceTableAcc";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { config } from "@frameworks/web/config/domain";
import { useNavigate } from "react-router-dom";
import { navigateSelf } from "./ServiceRequest";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import srDi from "./di/serviceLocator";
import { base64toPDF } from "@domains/utils/fileMethods";
import { AccountPopupsEnum, ELoginPopupState } from "../BasicProfile/constant";
import GenericDrawer from "@frameworks/web/components/generic/TOCgeneric/GenericDrawer";
import AccountsPopups from "../BasicProfile/AccountsPopups";
import { accountDetails } from "@mainDi/webDi";
import { reject } from "underscore";
import PopupWatchlist from "../WatchList/CommonWatchlist/PopupWatchlist";
import debounce from "@frameworks/web/utils/debounce";
import { searchMultipleKeys } from "@domains/utils/search";
import { ESortOrder, dateSort } from "@domains/utils/sort";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import di from "../BasicProfile/di/servicelocator";
import ThreeDotLoader from "@frameworks/web/components/generic/ThreeDotLoader";
import Toaster from "@frameworks/shared-library/components/Toast/Toast";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
var proceedToEsign = function (id, type, downloadPrefilled, url) { return __awaiter(void 0, void 0, void 0, function () {
    var pdf, esign, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 6]);
                return [4 /*yield*/, srDi.serviceRequest.preFilledFormPDF({
                        parentServiceId: id,
                        preFilledFormName: prefilledFormTypes[type].downloadName,
                    })];
            case 1:
                pdf = _a.sent();
                if (!pdf) return [3 /*break*/, 4];
                if (downloadPrefilled) {
                    base64toPDF(pdf, "PrefilledForm");
                }
                if (!url) return [3 /*break*/, 2];
                navigateSelf(url);
                return [3 /*break*/, 4];
            case 2: return [4 /*yield*/, srDi.serviceRequest.getESignURL({
                    id: id,
                    data: pdf,
                    returnUrl: "".concat(config.serviceRequest_base, "app/clientarea/service-request?mod=").concat(prefilledFormTypes[type].redirectionName, "&source=nsdl_onep&appID=").concat(btoa(id)),
                    sr: prefilledFormTypes[type].redirectionName,
                }, false)];
            case 3:
                esign = _a.sent();
                navigateSelf(esign);
                _a.label = 4;
            case 4: return [3 /*break*/, 6];
            case 5:
                error_1 = _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); }; // needs to implement
export var RenderLinkRedirection = function (_a) {
    var data = _a.data, reactList = _a.reactList, skipDate = _a.skipDate;
    var RequestStatus = data.RequestStatus, RequestType = data.RequestType, RequestId = data.RequestId, ExcepetedDateOfCompletion = data.ExcepetedDateOfCompletion, dormant_type = data.dormant_type, EsignUrl = data.EsignUrl;
    var redirectionToAddress = function (sr) {
        if (sr) {
            if (sr.is_digilocker_flow) {
                localStorage.setItem("digieResubmit", "Yes");
            }
            navigateSelf(SRRedirectionUrl[EServiceRequest.ADDRESS] + "&srID=" + sr.RequestId);
        }
    };
    switch (RequestStatus) {
        case "PendingForEsign":
            // if (
            //   ["Change of Address", "Equity Dormant Reactivation"].includes(
            //     RequestType
            //   )
            // ) {
            return (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Continue to E-sign", onClick: function () {
                    return proceedToEsign(RequestId, RequestType, true, EsignUrl);
                } }));
            // }
            break;
        case "Rejected - Resubmit":
            if (["Change of Address", "Bank Modification", "CKYC Update"].includes(RequestType)) {
                return (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Continue To Resubmit Process", onClick: function () {
                        RequestType === "CKYC Update"
                            ? navigateSelf(SRRedirectionUrl[EServiceRequest.CKYC] +
                                "&srID=" +
                                RequestId)
                            : RequestType === "Bank Modification"
                                ? navigateSelf(SRRedirectionUrl[EServiceRequest.BANK] +
                                    "&srID=" +
                                    RequestId)
                                : redirectionToAddress(data);
                    } }));
            }
            break;
        case "MemorandumPaymentPending":
            if (RequestType === "Equity Dormant Reactivation" &&
                (dormant_type.includes("1") || dormant_type.includes("6"))) {
                var isMemorandumPending = reactList &&
                    (reactList.find(function (list) { return list.RequestType === "Memorandum Recovery"; }).RequestStatus === "MemorandumPaymentPending" ||
                        reactList.find(function (list) { return list.RequestType === "Memorandum Recovery"; }).RequestStatus === "PaymentPending");
                if (isMemorandumPending) {
                    return (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Continue Pending Payment", onClick: function () {
                            return navigateSelf(SRRedirectionUrl[EServiceRequest.REACTIVATION]);
                        } }));
                }
                else {
                    if (!skipDate)
                        return (React.createElement(React.Fragment, null, moment(ExcepetedDateOfCompletion).format("DD MMM, YYYY , hh:mm:ss A")));
                }
            }
            break;
        case "Approved":
        case "InProcess":
        case "MemorandumPaymentPending":
        case "Draft Saved":
            if (RequestType === "Equity Dormant Reactivation" &&
                (dormant_type.includes("1") || dormant_type.includes("6"))) {
                return (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: " Continue Reactivation Process", onClick: function () {
                        return navigateSelf(SRRedirectionUrl[EServiceRequest.REACTIVATION]);
                    } }));
            }
            else {
                if (ExcepetedDateOfCompletion && !skipDate) {
                    return (React.createElement(React.Fragment, null, moment(ExcepetedDateOfCompletion).format("DD MMM, YYYY , hh:mm:ss A")));
                }
            }
            break;
        default:
            if (ExcepetedDateOfCompletion && !skipDate) {
                return (React.createElement(React.Fragment, null, moment(ExcepetedDateOfCompletion).format("DD MMM, YYYY , hh:mm:ss A")));
            }
            break;
    }
    return React.createElement(React.Fragment, null);
};
export var SRStatusUpdate = function (Status, Type) {
    var _a, _b;
    var statusColor = "";
    Status = SRStatusMapping[Type]
        ? (_a = SRStatusMapping[Type][Status]) === null || _a === void 0 ? void 0 : _a.value
        : (_b = SRStatusDefaultMapping[Status]) === null || _b === void 0 ? void 0 : _b.value;
    switch (Status) {
        case "In Process":
            statusColor = "InProcess";
            break;
        case "Rejected":
            statusColor = "Rejected";
            break;
        case "Pending":
            statusColor = "Pending";
            break;
        case "Completed":
            statusColor = Type === "Equity Dormant Reactivation" ? Status : "Closed";
            break;
        case "Submit":
            statusColor = "Submit";
            break;
        case "Delivered":
            statusColor = "Delivered";
            break;
        default:
            statusColor = "";
    }
    return statusColor;
};
var ServiceRequestTable = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var navigate = useNavigate();
    var device = DeviceContext();
    var _l = __read(useState({
        accType: "",
        mergeStatus: "",
    }), 2), accountState = _l[0], setAccountState = _l[1];
    var _m = __read(useState(AccountPopupsEnum.DEFAULT), 2), screenState = _m[0], setScreenState = _m[1];
    var _o = __read(useState(), 2), toggledAcc = _o[0], settoggledAcc = _o[1];
    var _p = __read(useState(), 2), acc_type = _p[0], setAccountType = _p[1];
    var _q = __read(useState(false), 2), searchState = _q[0], setSearchState = _q[1];
    var _r = __read(React.useState(""), 2), searchVal = _r[0], setSearchVal = _r[1];
    var _s = __read(useState(false), 2), loader = _s[0], setLoader = _s[1];
    var _t = __read(React.useState(false), 2), errMessage = _t[0], setErrMessage = _t[1];
    var _u = __read(useState(undefined), 2), nriDetails = _u[0], setNRIDetails = _u[1];
    var accData = JSON.parse(localStorage.getItem("acc_data"));
    var ServiceRequestColumn = useMemo(function () { return [
        {
            columnName: "Date & Time",
            key: "createdDate",
            type: "string",
            arrows: true,
            applySorting: true,
            tdCustomFunction: function (date) {
                return moment(date).format("DD MMM, YYYY hh:mm:ss A");
            },
        },
        {
            columnName: "Request ID",
            arrows: false,
            key: "RequestId",
        },
        {
            columnName: "Request",
            arrows: false,
            key: "RequestType",
        },
        {
            columnName: "Expected Date of Completion",
            arrows: false,
            key: "ExcepetedDateOfCompletion",
            tdCustomFunction: function (date) {
                return !!date ? moment(date).format("DD MMM, YYYY hh:mm:ss A") : "";
            },
        },
        {
            columnName: "Status",
            arrows: false,
            keysForCustomFunction: [
                "RequestStatus",
                "RequestType",
                "creator_remarks",
                "approver_remarks",
            ],
            tdCustomFunction: function (_a) {
                var _b = __read(_a, 4), Status = _b[0], Type = _b[1], creator_remarks = _b[2], approver_remarks = _b[3];
                var statusColor = SRStatusUpdate(Status, Type);
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "d-center-start brdradius-5 service-request-content" },
                        React.createElement("div", { className: "DMSans_16_500 px-2 p-1 status-div txt-".concat(statusColor) }, statusColor),
                        ((Type !== "Online Closure" && creator_remarks) ||
                            (Type === "Online Closure" && approver_remarks)) && (React.createElement("div", { className: "posrel" },
                            React.createElement(GenericTooltip, { placement: "top", button: React.createElement("span", { className: "ps-2 edel-icon-table-chat txt-midnight-blue" }), triggerType: "hover", externalClassName: "hand_cursor common-tooltip  ms-3", toolTipText: "".concat(creator_remarks || approver_remarks, " "), toolTipClassName: "common-white-tooltip" }))))));
            },
        },
        {
            columnName: "",
            arrows: false,
            key: "contact",
            keysForCustomFunction: ["contact", "srvcRmName"],
            tdCustomFunction: function (keys) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSans_16_500 txt-midnight-blue d-flex hand_cursor", onClick: function () {
                            navigate("/profile?parentSection=Support&section=WealthAdvisors&subSection=RatingAdvisors");
                        } }, "Contact your RM"),
                    React.createElement("span", { className: "DMSansMedium_12_500 txt_primaryGrey d-flex" }, keys[1])));
            },
        },
    ]; }, []);
    var getNRIDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload;
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = {};
                    return [4 /*yield*/, (accountDetails === null || accountDetails === void 0 ? void 0 : accountDetails.getPreferedAccountCodeID())];
                case 1:
                    payload = (_a.accTyp = (_b = (_c.sent())) === null || _b === void 0 ? void 0 : _b.accTyp,
                        _a);
                    setLoader(true);
                    di.basicProfile
                        .getClientcategoryNRI(payload)
                        .then(function (result) {
                        var _a;
                        if (result) {
                            setNRIDetails(eval(JSON.parse(JSON.stringify((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.value))));
                            setLoader(false);
                            setequitycommodityCheck();
                        }
                    })
                        .catch(function (error) {
                        setLoader(false);
                        setErrMessage(true);
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        var accData = {
            accType: "",
            mergeStatus: "",
        };
        accountDetails
            .getAccTyp()
            .then(function (x) {
            setAccountType(x);
            accData.accType = x;
            if (x === "COMEQ") {
                accountDetails
                    .prefAccTyp()
                    .then(function (y) {
                    if (y === undefined) {
                        settoggledAcc("EQ");
                    }
                    else {
                        settoggledAcc(y);
                    }
                })
                    .catch(function (err) {
                    reject(err);
                });
            }
        })
            .catch(function (err) {
            reject(err);
        });
        accountDetails
            .getAccountMrgSts()
            .then(function (x) {
            return setAccountState({
                accType: accData.accType,
                mergeStatus: x,
            });
        })
            .catch(function (err) {
            reject(err);
        });
    }, []);
    var srList = useMemo(function () {
        try {
            if (searchVal.length >= 3) {
                props === null || props === void 0 ? void 0 : props.setLoader(true);
                var searchData = searchMultipleKeys(props.requestList, ["RequestId", "RequestType"], searchVal);
                if ((searchData === null || searchData === void 0 ? void 0 : searchData.length) === 0) {
                    props === null || props === void 0 ? void 0 : props.setLoader(false);
                    props === null || props === void 0 ? void 0 : props.setMsg({
                        msg: "No matching result found",
                        show: true,
                        icon: "",
                    });
                    return [];
                }
                else {
                    props === null || props === void 0 ? void 0 : props.setLoader(false);
                    props === null || props === void 0 ? void 0 : props.setMsg({
                        msg: "",
                        show: false,
                        icon: "",
                    });
                    return searchData;
                }
            }
            else {
                props === null || props === void 0 ? void 0 : props.setLoader(false);
                return props.requestList;
            }
        }
        catch (error) {
            return props === null || props === void 0 ? void 0 : props.requestList;
        }
    }, [props === null || props === void 0 ? void 0 : props.requestList, searchVal, searchState]);
    var setequitycommodityCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
        var temp;
        var _a, _b;
        return __generator(this, function (_c) {
            if (((_b = (_a = nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.AccountCategory) === "NRI") {
                setScreenState(AccountPopupsEnum.NRI_ACCOUNT);
            }
            else {
                if (accountState.mergeStatus === ELoginPopupState.NOT_ENABLED &&
                    (accountState.accType === "CO" || accountState.accType === "EQ")) {
                    setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                }
                else if (accountState.accType === "COMEQ") {
                    // setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                    if (accountState.mergeStatus === "COMPLETED") {
                        temp = accData;
                        temp.prefAccTyp = accData.prefAccTyp === "EQ" ? "CO" : "EQ";
                        localStorage.setItem("acc_data", JSON.stringify(temp));
                        location === null || location === void 0 ? void 0 : location.reload();
                    }
                    else {
                        setScreenState(AccountPopupsEnum.SWITCH_TO_OTHER_ACC);
                    }
                }
                else {
                    setScreenState(AccountPopupsEnum.NEW_ACCOUNT);
                }
            }
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        (props === null || props === void 0 ? void 0 : props.loader) ? (
        // || accountState?.accType?.length === 0
        React.createElement("div", { className: "d-flex justify-content-center" },
            React.createElement(Common_Shimmer, null))) : (React.createElement(Row, { className: "mx-0" },
            React.createElement(Col, { lg: 12, className: "px-0 d-space-between toogle-switch-sr mgt-20 mb-20" },
                loader ? (React.createElement(React.Fragment, null,
                    React.createElement(ThreeDotLoader, null))) : (React.createElement("div", { className: "d-flex align-items-center" },
                    React.createElement("span", { className: accountState.accType !== "EQ"
                            ? "DMSan_14_500 txt-midnight-blue pe-1"
                            : "DMSanN_14_400 txt_blackOne1 pe-1" }, "Equity"),
                    React.createElement("span", null,
                        React.createElement(ToggleSwitch, { id: "account", name: "account", checked: acc_type !== "COMEQ"
                                ? (accountState === null || accountState === void 0 ? void 0 : accountState.accType) === "EQ"
                                    ? false
                                    : true
                                : (accData === null || accData === void 0 ? void 0 : accData.prefAccTyp) === "EQ"
                                    ? false
                                    : true, onChange: function () {
                                getNRIDetails();
                            }, small: true, switchcolorClass: "midnight-blue" })),
                    React.createElement("span", { className: accountState.accType !== "EQ"
                            ? "DMSan_14_500 txt-midnight-blue ps-1"
                            : "DMSanN_14_400 txt_blackOne1 ps-1" }, "Commodity"))),
                React.createElement("div", { className: "pe-md-2 pe-0" },
                    React.createElement("div", { className: "common-search-input-sr" },
                        React.createElement("div", { className: "search-bar" },
                            React.createElement(SearchBar, { openInputBackground: "bg_aqua_white", searchBarBackground: "bg_aqua_white", deskPlaceHolder: "Search", iconColors: "txt-midnight-blue", parentClassName: "event-calendar-search service-request-search ".concat((device === null || device === void 0 ? void 0 : device.isDesktop) ? "" : ""), defaultValue: searchVal, onFocus: function () { return setSearchState(true); }, onCallbackFunction: function (text) {
                                    if ((text === null || text === void 0 ? void 0 : text.length) >= 3) {
                                        debounce(function () {
                                            return __awaiter(this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    setSearchVal(text);
                                                    return [2 /*return*/];
                                                });
                                            });
                                        }, 300)();
                                    }
                                }, onBack: function () {
                                    setSearchState(false);
                                    setSearchVal("");
                                }, disabled: !(((_a = props.requestList) === null || _a === void 0 ? void 0 : _a.length) > 0) }))))))),
        (props === null || props === void 0 ? void 0 : props.loader) ? (React.createElement("div", { className: "d-flex justify-content-center" },
            React.createElement(Spinner, { animation: "border" }))) : ((_b = props === null || props === void 0 ? void 0 : props.validationMessage) === null || _b === void 0 ? void 0 : _b.show) ? (React.createElement(Errormsg, { msg: (_c = props === null || props === void 0 ? void 0 : props.validationMessage) === null || _c === void 0 ? void 0 : _c.msg, showIcon: true })) : ((_d = props === null || props === void 0 ? void 0 : props.error) === null || _d === void 0 ? void 0 : _d.isOpen) ? (React.createElement(ErrorNotification, { displayType: ErrorDisplayType === null || ErrorDisplayType === void 0 ? void 0 : ErrorDisplayType.INSECTION, isOpen: (_e = props === null || props === void 0 ? void 0 : props.error) === null || _e === void 0 ? void 0 : _e.isOpen, error: (_f = props === null || props === void 0 ? void 0 : props.error) === null || _f === void 0 ? void 0 : _f.error })) : (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null, (srList === null || srList === void 0 ? void 0 : srList.length) > 0 && (React.createElement(DynamicPagination, { dataLengthPerPage: 5, data: dateSort(srList, "createdDate", ESortOrder.DESC), columns: ServiceRequestColumn, Bodycomponent: ServiceTableAcc, parentClassName: "table common-table-border custom-pagination-new", next: true, prev: true, viewAll: true })))) : (React.createElement(React.Fragment, null,
            React.createElement(Row, { className: "mx-0" },
                React.createElement(Col, { lg: 12, className: "px-0" }, (srList === null || srList === void 0 ? void 0 : srList.length) > 0 && (React.createElement(DynamicPagination, { dataLengthPerPage: 10, data: dateSort(srList, "createdDate", ESortOrder.DESC), columns: ServiceRequestColumn, Bodycomponent: ServiceRequestTablemb, parentClassName: "table common-table-border", infinityScroll: true, viewAll: true })))))),
        React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null, ((_h = (_g = nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.AccountCategory) === "NRI" ? (React.createElement("div", { className: "profiledata-popup" },
            React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "NRI Account", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: screenState === AccountPopupsEnum.NRI_ACCOUNT, setShow: function () {
                    setequitycommodityCheck();
                }, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, nriDetails: nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data, btnvalueleft: screenState === AccountPopupsEnum.NRI_ACCOUNT
                        ? {
                            value: "Back",
                            btnTyp: "midnight-blue-border",
                            className: "",
                        }
                        : null }) }))) : (React.createElement(React.Fragment, null,
            " ",
            React.createElement("div", { className: "profiledata-popup" },
                React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "Switch account type", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: screenState !== AccountPopupsEnum.DEFAULT, setShow: function () { return setScreenState(AccountPopupsEnum.DEFAULT); }, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, nriDetails: nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data, btnvalueleft: screenState === AccountPopupsEnum.NEW_ACCOUNT
                            ? {
                                value: "No, thanks",
                                btnTyp: "midnight-blue-border",
                                className: "",
                            }
                            : screenState ===
                                AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                                ? {
                                    value: "Cancel",
                                    btnTyp: "midnight-blue-border",
                                    className: "",
                                }
                                : screenState === AccountPopupsEnum.SUCCESS_RESULT
                                    ? {
                                        value: "Ok, Got it",
                                        btnTyp: "midnight-blue-border",
                                        onClick: function () {
                                            return setScreenState(AccountPopupsEnum.DEFAULT);
                                        },
                                    }
                                    : null, btnvalueright: screenState === AccountPopupsEnum.NEW_ACCOUNT
                            ? {
                                value: "Yes, right away",
                                btnTyp: "midnight-blue",
                                className: "",
                            }
                            : screenState ===
                                AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                                ? {
                                    value: "Yes",
                                    btnTyp: "midnight-blue",
                                    className: "",
                                }
                                : null }) })))))) : (React.createElement(React.Fragment, null, ((_k = (_j = nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data) === null || _j === void 0 ? void 0 : _j.value) === null || _k === void 0 ? void 0 : _k.AccountCategory) === "NRI" ? (React.createElement("div", { className: "mb-genericSidebar" },
            React.createElement(GenericDrawer, { show: screenState !== AccountPopupsEnum.DEFAULT, setShow: function () { return setScreenState(AccountPopupsEnum.DEFAULT); }, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "NRI account")), bodyComp: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, nriDetails: nriDetails === null || nriDetails === void 0 ? void 0 : nriDetails.data, btnvalueleft: screenState === AccountPopupsEnum.NRI_ACCOUNT
                        ? {
                            value: "Back",
                            btnTyp: "midnight-blue-border",
                            className: "",
                        }
                        : null }) }))) : (React.createElement("div", { className: "mb-genericSidebar" },
            React.createElement(GenericDrawer, { show: screenState !== AccountPopupsEnum.DEFAULT, setShow: function () { return setScreenState(AccountPopupsEnum.DEFAULT); }, parentClass: "z-index-high", headerComp: React.createElement(React.Fragment, null,
                    React.createElement("label", { className: "term-heading DMSan_16_700 txt_blackOne1" }, "Switch account type")), bodyComp: React.createElement(AccountsPopups, { accountState: accountState, screenState: screenState, setScreenState: setScreenState, toggledAcc: toggledAcc, btnvalueleft: screenState === AccountPopupsEnum.NEW_ACCOUNT
                        ? {
                            value: "No",
                            btnTyp: "midnight-blue-border",
                            className: "",
                        }
                        : screenState ===
                            AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                            ? {
                                value: "Cancel",
                                btnTyp: "midnight-blue-border",
                                className: "",
                            }
                            : screenState === AccountPopupsEnum.SUCCESS_RESULT
                                ? {
                                    value: "Ok, Got it",
                                    btnTyp: "midnight-blue-border",
                                    onClick: function () {
                                        return setScreenState(AccountPopupsEnum.DEFAULT);
                                    },
                                }
                                : null, btnvalueright: screenState === AccountPopupsEnum.NEW_ACCOUNT
                        ? {
                            value: "Yes",
                            btnTyp: "midnight-blue",
                            className: "",
                        }
                        : screenState ===
                            AccountPopupsEnum.SWITCH_TO_OTHER_ACC
                            ? {
                                value: "Yes",
                                btnTyp: "midnight-blue",
                                className: "",
                            }
                            : null }) })))))),
        errMessage && (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isDesktop) && (React.createElement(PopupWatchlist, { size: "modal-size-660 modal-dialog-centered", icon: "edel-icon-download1", title: "", modalTitle: "modalwatchlist commonmodal", showFooter: false, show: errMessage, setShow: setErrMessage, showCloseIcon: true, closeicon: "edel-icon-bold-close", children: React.createElement("div", { className: "mb-30 mt-30" }, "Something went wrong! Please try after sometime.") })))),
        errMessage && (React.createElement(React.Fragment, null, (device === null || device === void 0 ? void 0 : device.isMobile) && (React.createElement(React.Fragment, null,
            React.createElement(Toaster, { parentClass: "position-relative margin-toast", show: errMessage, setShow: setErrMessage, position: "middle-center", message: " Something went wrong! Please try after sometime." })))))));
};
export default ServiceRequestTable;
